import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { DashboardResponsiveApiModelSparse } from 'src/shared/models/dashboard.model';

@Component({
    selector: 'cv-share-text-renderer',
    templateUrl: './share-text-renderer.component.html',
    styleUrls: ['./share-text-renderer.component.scss']
})
export class ShareTextRendererComponent implements AgRendererComponent {
    params: ICellRendererParams;
    value: string;
    canShare: boolean;

    agInit(params: ICellRendererParams) {
        this.params = params;
        this.value = params.value;
        this.canShare = this.params.context.contextUtil.hasWriteAccess(params.data);

        this.params.eGridCell.addEventListener("keypress", () => this.shareTextClicked());
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        this.value = params.value;
        this.canShare = this.params.context.contextUtil.hasWriteAccess(params.data);
        return true;
    }

    shareTextClicked() {
        const dashboard: DashboardResponsiveApiModelSparse = this.params.data;
        this.params.context.contextUtil.shareDashboard(dashboard);
    }
}
